import { useEffect, useState } from 'react';
import { Api } from '../../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
//import './FT.css';
import { useParams } from 'react-router-dom';
import * as moment from 'moment'
import './FT.css';




const modeloDatos = {
    recetaID: 0,
    empresaID: 1,
    pacienteID: 0,
    recordPacienteID: 0,
    medicamentoID: 0,
    nombreMedicamento: '',
    fecha: new Date,
    comentario: '',
    fechaCreado: new Date,
    creadoPor: ''
}
const modeloDatosP = {
    pacienteID: 0,
    empresaid: 0
    , nombres: ''
    , apellidos: ''
    , cedula: ''
    , telefono: ''
    , celular: ''
    , fechaNacimiento: new Date
    , sexo: ''
    , tipoOrden: 0
    , seguroID: 0
    , nombreSeguro: ''
    , poliza: ''
    , centroID: 0
    , diagnostico: ''
    , diagnosticoClinico: ''
    , direccion: ''
    , tratamientoID: 0
    , nombreTratamiento: ''
    , resultado: ''
    , toxicos: ''
    , creadoPor: ''
    , fechaCreado: new Date
    , modificadoPor: ''
    , fechaModificado: new Date
    , imagen: ''


}

const ImpresionReceta = () => {
    const { Pedido, Reporte, Modulo } = useParams();
 
  
    const [Listado, SetListado] = useState([]);
    const [Record, SetRecord] = useState(modeloDatos);
    const [VerImprimir, SetVerImprimir] = useState(false);
    const [ApiR, setApiR] = useState("");
    const [Nombre, setNombre] = useState("");

    

    const obtenerDatos = async () => {
        var ap = "";
        if (Modulo == "Ginecologo") {
            ap = "Ginecologo/ImpresionRecetas/"
        } else { ap = "Pacientes/ImpresionRecetas/" }
        let response = await fetch(Api + ap + Pedido);
        if (response.ok) {
            let data = await response.json()
            SetRecord(data);
           obtenerDatosp(data[0].codigoUnicoPaciente)
        
        //    ObtenerReceta(data.recordPacienteID)
            setApiR(Api + ap + Pedido)
        }
    }
    const obtenerDatosp = async (d) => {
        var ap = "";
        if (Modulo == "Ginecologo") {
            ap = "Ginecologo/GetGinecologo/";
        } else { ap = "Pacientes/GetGastro/"; }
            let response = await fetch(Api + ap+d);
        if (response.ok) {
            let data = await response.json();
            setNombre(data.nombres + " " + data.apellidos)
          //  SetRecordP(data);
        }
    }



    const ObtenerReceta = async (d) => {
        let response = await fetch(Api + "Pacientes/Recetas/" + d);
        if (response.ok) {
            let data = await response.json()
            SetListado(data)
        }
    }
    useEffect(() => {
       obtenerDatos()
        
    }, [])

   

    return (
        <>
           
                {<iframe
                src={"/Informes/Consultorio/" + Reporte  + "?API=" + ApiR + "&Nombre=" + Nombre}
                    title="Contenido HTML"
                    style={{ width: '100%', height: '1100px', border: 'none' }}

                />}

                {/* Botón para imprimir */}


        </>
        )

}
export default ImpresionReceta;